// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colors */
/* Layout tokens */
/* Export CSS variables */
:root {
  --page-bg: #f6f7f9;
  --panel-bg: #ffffff;
  --muted: #6b7280;
  --text: #0f1724;
  --accent-green: #2ea44f;
  --accent-yellow: #ffb020;
  --accent-orange: #ff7a00;
  --danger: #d9534f;
  --card-border: rgba(15, 23, 42, 0.06);
  --radius-lg: 10px;
  --radius-md: 8px;
  --shadow-soft: 0 10px 30px rgba(16, 24, 40, 0.06);
  --gutter: 24px;
  --max-width: 1180px;
  --font-stack: Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica Neue, Arial;
}

.noEasyPay_mmaError__rC-yu {
  margin-bottom: 18px;
}

.noEasyPay_card__2rBIv {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  padding: 18px;
}

.noEasyPay_tru-mma-main-content__ntPb9 .noEasyPay_align-items-center__DzGgA.noEasyPay_row__Ct\\+2Y {
  align-items: center;
}

.noEasyPay_col-md-2__c3zp6 img {
  width: 56px;
  height: 56px;
  object-fit: contain;
}

.noEasyPay_gfs-24__EpI6z {
  font-size: 24px;
  font-weight: 700;
  color: #0f1724;
}

.noEasyPay_text-muted__H7x6i {
  color: #6b7280;
  font-size: 14px;
}

@media (max-width: 768px) {
  .noEasyPay_col-md-2__c3zp6 img {
    width: 48px;
    height: 48px;
  }
  .noEasyPay_gfs-24__EpI6z {
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/_easyPayTokens.scss","webpack://./src/styles/noEasyPay.module.scss"],"names":[],"mappings":"AAGA,WAAA;AAaA,kBAAA;AAQA,yBAAA;AACA;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,wBAAA;EACA,wBAAA;EACA,iBAAA;EACA,qCAAA;EACA,iBAAA;EACA,gBAAA;EACA,iDAAA;EACA,cAAA;EACA,mBAAA;EACA,sFAAA;ACrBJ;;AAhBA;EACI,mBAAA;AAmBJ;;AAhBA;EACI,mBDHO;ECIP,mBDQQ;ECPR,wCAAA;EACA,aAAA;AAmBJ;;AAhBA;EACI,mBAAA;AAmBJ;;AAhBA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAmBJ;;AAhBA;EACI,eAAA;EACA,gBAAA;EACA,cDpBG;ACuCP;;AAhBA;EACI,cDzBI;EC0BJ,eAAA;AAmBJ;;AAhBA;EACI;IACI,WAAA;IACA,YAAA;EAmBN;EAhBE;IACI,eAAA;EAkBN;AACF","sourcesContent":["// styles/_easyPayTokens.scss\n$font-stack: \"Inter\", system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial !default;\n\n/* Colors */\n$page-bg: #f6f7f9 !default;\n$panel-bg: #ffffff !default;\n$muted: #6b7280 !default;\n$text: #0f1724 !default;\n$accent-green: #2ea44f !default;\n$accent-green-600: #1f8a3a !default;\n$accent-yellow: #ffb020 !default;\n$accent-yellow-600: #e09b00 !default;\n$accent-orange: #ff7a00 !default;\n$danger: #d9534f !default;\n$card-border: rgba(15, 23, 42, 0.06) !default;\n\n/* Layout tokens */\n$radius-lg: 10px !default;\n$radius-md: 8px !default;\n$shadow-soft: 0 10px 30px rgba(16, 24, 40, 0.06) !default;\n$shadow-sm: 0 8px 24px rgba(16, 24, 40, 0.06) !default;\n$gutter: 24px !default;\n$max-width: 1180px !default;\n\n/* Export CSS variables */\n:root {\n    --page-bg: #{$page-bg};\n    --panel-bg: #{$panel-bg};\n    --muted: #{$muted};\n    --text: #{$text};\n    --accent-green: #{$accent-green};\n    --accent-yellow: #{$accent-yellow};\n    --accent-orange: #{$accent-orange};\n    --danger: #{$danger};\n    --card-border: #{$card-border};\n    --radius-lg: #{$radius-lg};\n    --radius-md: #{$radius-md};\n    --shadow-soft: #{$shadow-soft};\n    --gutter: #{$gutter};\n    --max-width: #{$max-width};\n    --font-stack: #{$font-stack};\n}","// styles/noEasyPay.module.scss\n@use './_easyPayTokens' as tokens;\n\n.mmaError {\n    margin-bottom: 18px;\n}\n\n.card {\n    background: tokens.$panel-bg;\n    border-radius: tokens.$radius-lg;\n    border: 1px solid tokens.$card-border;\n    padding: 18px;\n}\n\n.tru-mma-main-content .align-items-center.row {\n    align-items: center;\n}\n\n.col-md-2 img {\n    width: 56px;\n    height: 56px;\n    object-fit: contain;\n}\n\n.gfs-24 {\n    font-size: 24px;\n    font-weight: 700;\n    color: tokens.$text;\n}\n\n.text-muted {\n    color: tokens.$muted;\n    font-size: 14px;\n}\n\n@media (max-width: 768px) {\n    .col-md-2 img {\n        width: 48px;\n        height: 48px;\n    }\n\n    .gfs-24 {\n        font-size: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mmaError": `noEasyPay_mmaError__rC-yu`,
	"card": `noEasyPay_card__2rBIv`,
	"tru-mma-main-content": `noEasyPay_tru-mma-main-content__ntPb9`,
	"align-items-center": `noEasyPay_align-items-center__DzGgA`,
	"row": `noEasyPay_row__Ct+2Y`,
	"col-md-2": `noEasyPay_col-md-2__c3zp6`,
	"gfs-24": `noEasyPay_gfs-24__EpI6z`,
	"text-muted": `noEasyPay_text-muted__H7x6i`
};
export default ___CSS_LOADER_EXPORT___;
